import React, { useState, useEffect } from "react";
import { Col, FormGroup, Modal, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, Navigate, useLocation, useNavigate, useOutletContext, useParams } from "react-router-dom";
import { Input, Label } from "reactstrap";
import { Oval } from 'react-loader-spinner'
import { getArtworkForm, getItemsById, getParticularOwner, getParticularSellItem } from "store/actions";
import PreviewNFT from "Pages/SaleNft/PreviewNFT";
import moment from "moment";
import toastr from "toastr";
import NFTPurchasecenter from "Pages/NFTPurchase/NFTPurchasecenter";
import { converCryptoToDollar } from "helpers/constants";
import Web3Intraction from "utils/web3Intraction";
import moment1 from "moment-timezone";
import useMetaMask from "hooks/metsmask";
import Timer from "Component/Timer/Timer";
import ViewSaleNFT from "Pages/SaleNft/viewNFT";
export default function ViewOwnedNft(props) {
  const [buyDialog, setbuyDialog] = useState(false)
  const wallAddress = localStorage.getItem("walletAddress");
  const [serviceAgree, setserviceAgree] = useState(false);
  const [menu, menuopen] = useOutletContext();
  const hooks = useMetaMask();
  useEffect(() => {
    menu(false)
  }, [menu])
  const dispatch = useDispatch()
  const { id } = useParams()
  const [ownednft] = useState(props.data);

  const item = useSelector((x) => x?.SellItems?.sellItem);
  const { sellItem } = useSelector((x) => x?.SellItems);
  const { loading } = useSelector((x) => x?.SellItems);
  const navigate = useNavigate();
    const { artWorkForm } = useSelector((state) => state?.Print);
    const  artWorkFormLoading  = useSelector((state) => state?.Print?.loading);
  const {  user, settings } = useSelector((state) => state?.Login);
  const [resaleActive, setresaleActive] = useState(false)
  const [otherFiles, setOtherFiles] = useState([])
  const [time, setTime] = useState('')
  const [nftPage, setNftPage] = useState(false)
  const [dateDifference, setdateDifference] = useState(false)
  const location = useLocation()
  const [ownership, setOnwerShip] = useState()
  const [daysLeft, setDaysLeft] = useState(0)
  const resaleBtn = () => {
    setresaleActive(true)
  }

  useEffect(() => {

    let x = location.pathname.split("/")[2]
    if (x === 'nft') {
      setNftPage(true)
    } else {
      setOnwerShip(location.state)
    }
  }, [location])
  useEffect(() => {
    setOtherFiles(item?.relatedImages)

  }, [item])


  useEffect(() => {
    dispatch(getParticularSellItem(id))
  }, [id])

  const [isExpired, setExpire] = useState(false)
  const [availableCopies, setAvailableCopies] = useState();
  const [currentPrice, setCurrentPrice] = useState();
  const [usdPrice, setUsdPrice] = useState({

  });

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      const calPrice = async (currentPrice) => {
        let amount = currentPrice;
        let symbol = "MATIC"

        let data = await converCryptoToDollar(amount, symbol);
        setUsdPrice(
          data
        );
      };
      calPrice(currentPrice);
    }, 300);
    return () => clearTimeout(delayDebounceFn);
  }, [currentPrice, item?.blockchain]);

  useEffect(() => {
    if (id && user) {
      let particualrOwnerdata = {}

      particualrOwnerdata.owner_id = user?._id
      particualrOwnerdata.sellItem_id = id
      const getParticularOwnerCallback = (res) => {
        setAvailableCopies(res.data[0].available_copies);
        setCurrentPrice(res.data[0].price)
      }

      dispatch(getParticularOwner(particualrOwnerdata, getParticularOwnerCallback))
    }
  }, [id, user, dispatch])



  useEffect(() => {
    const calculateDateDifference = () => {
      setExpire(false)
      const endDate = new Date((item?.auction_time) * 1000)
      const startDate = new Date;

      const differenceInMilliseconds = endDate - startDate;
      if (differenceInMilliseconds > 0) {
        const months = Math.floor(differenceInMilliseconds / (1000 * 60 * 60 * 24 * 30.44));
        const days = Math.floor((differenceInMilliseconds % (1000 * 60 * 60 * 24 * 30.44)) / (1000 * 60 * 60 * 24));
        const hours = Math.floor((differenceInMilliseconds % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((differenceInMilliseconds % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((differenceInMilliseconds % (1000 * 60)) / 1000);

        return { months, days, hours, minutes, seconds };
      } else {
        setExpire(true)


      }
      return {}
    };
    setdateDifference(calculateDateDifference())
  }, [item])

  const [viewnftDialog, setviewnftDialog] = useState(false)
  const [nftlink, setNftLink] = useState()
  const viewnftBtn = (nftlink, nftName) => {
    setviewnftDialog(!viewnftDialog)
    const data = {
      nftLink: nftlink,
      nftName: nftName
    }
    setNftLink(data)
  }

  function downloadImage() {
    const link = item?.nft_id?.image_id?.image?.link;
    if (link) {
      window.open(link, '_blank');
    } else {
      alert("Link not available for download.");
    }
  }

  const buynowBtn = () => {
    setbuyDialog(!buyDialog)
  }

  function serviceag() {
    setserviceAgree(true)
  }
  function closeTerms() {

    setserviceAgree(false)

  }

  const activateSell = async (wallet_owner, tokenId, id, trans, to_wallet, from_wallet) => {
    let blockchain = "Polygon";
    try {

      const web3intraction = new Web3Intraction(
        blockchain,
        hooks?.walletType,
        settings
      );

      if (!web3intraction.isNetworkServiceWorking()) {
        // setinternalLoading(false);

        return toastr.error("Service Not Available!");
      }

      let data = {
        name: item?.nft_id?.name,
        creator: user?._id,
        price: "abc",
        token: item?.nft_id?.token_id,
        // auctionduration:(fields?.auction_length)*86400,
        royaltyPercentage: item?.loaylty
      }
      return await web3intraction.resellNFT(
        wallAddress,
        data
      ).then((res) => {

        if (res.status) {
        } else {
          toastr.error("Transaction declined");
        }
      })
    } catch (err) {
      toastr.error("Something went wrong");
      // setnftCreate(false);
      console.log(err)
    }

  }
  useEffect(() => {
    const timezone = moment.tz.guess();
    const timezoneOffset = moment.tz(timezone).utcOffset();
    if (item?.sellType === "auction") {
      const localMoment = convertUtcToLocal(item?.auction_time, timezoneOffset);
      const date_end = localMoment.format('YYYY-MM-DD HH:mm:ss');
      setTime(date_end);
      const today = moment().startOf('day');
      const auctionTimeMoment = moment.unix(item?.auction_time).local();
      const daysLeft = auctionTimeMoment.diff(today, 'days');
      setDaysLeft(daysLeft);
    }
  }, [item]);
  const [isChecked, setIsChecked] = useState(false);

  const [showNFT, setshowNFT] = useState(false);

  const ViewNFT = () => {
    setshowNFT(!showNFT);
  };



  useEffect(() => {
    if (sellItem?._id && sellItem?.nft_id?.image_id?._id) {
      dispatch(getArtworkForm({ nft_id: sellItem?.nft_id?._id, art_id: sellItem?.nft_id?.image_id?._id }))
    }
    console.log("sellItem", sellItem)
  }, [sellItem, dispatch])
  return (

    <>
      {(loading || artWorkFormLoading)&&
        <div className='loaderBoxMiane'>
          <Oval
            height={80}
            width={80}
            color="#6C63FF"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            ariaLabel='oval-loading'
            secondaryColor="#6C63FF"
            strokeWidth={2}
            strokeWidthSecondary={2}

          />
        </div>
      }
      <Modal
        className="termandCoDialog"
        show={serviceAgree}
        centered
        animation={false}
      >
        <div className="text-end">
          <button onClick={closeTerms} className="btn cancelbtn end-0 top-0">
            <img src="/images/svg/closeIconDialog.svg" alt="" />
          </button>
        </div>
        <div className="contentBoxdialog">
          <NFTPurchasecenter />
          <button
            className="btn btn-primary px-5 btn-sm py-2"
            onClick={closeTerms}
          >
            Back
          </button>
        </div>

      </Modal>
      <Modal className="EmailVerifyBoxModel previewnftDialog text-center" show={viewnftDialog} centered animation={false}>
        <PreviewNFT fucn={viewnftBtn} nftData={item} />
      </Modal>
      <Modal className="EmailVerifyBoxModel buynowDialog text-center" show={buyDialog} centered animation={false}>

        <div className="buyNowBox">
          <div className="nftnameBox">
            <div className="nftname">
              <div className="nftImg">
                <img src={(item?.nft_id?.image_id?.image?.link)} className="img-fluid" alt="" />
              </div>

              <h3>{item?.nft_id?.name}</h3>
            </div>

          </div>
        </div>
        <div className="buyNowBox">
          <div className="nftnameBox">
            <div className="nftname">
              <div className="nftImg">
                <img src="/images/svg/maticIcon.svg" className="img-fluid" alt="" />
              </div>
              <div>
                {(wallAddress && wallAddress != "undefined") ? <><h3>{wallAddress?.substring(0, 7) + "......" + wallAddress?.substring(32)}</h3></> : <h3>*******</h3>}
                <p>POL</p>
              </div>
            </div>
            <div className="nftprice">
              {(wallAddress && wallAddress != "undefined") ? <button className="connected">Connected</button> : <button className="connected">Not Connected</button>}
            </div>
          </div>
        </div>
        <div className="buyNowBox">

          <div className="nftnameBox border-0  px-0 rounded-0">
            <h3>Buying Price</h3>
            <h3>{currentPrice} POL ({"$" + usdPrice})</h3>
          </div>
          <div className="nftnameBox border-0  px-0 rounded-0">
            <h3>Available Copies</h3>
            {/* <h3>{availableCopies}</h3> */}
            <h3>{item?.available_copies}</h3>
          </div>
          <div className="nftnameBox border-0 px-0 rounded-0 pb-1">
            <h3>Price</h3>
            <h3>
              <Input type="number" className="form-control" placeholder="Enter Price" disabled={!wallAddress} />
            </h3>
          </div>
          <div className="nftnameBox border-0 px-0 rounded-0 pb-1">
            <h3>Quantity</h3>
            <h3>
              <Input type="number" className="form-control" placeholder="Enter Quantity" disabled={!wallAddress} />
            </h3>
          </div>



        </div>
        <div className="buyNowBox">
          <div className="CustomeCheckBox">
            <Input type="checkbox" id="Agreement" />
            <label className="cursor-pointer" htmlFor="Agreement"></label>
            <div><span className=" text-black">I agree to  <span
              onClick={serviceag}
              className="link_text mb-0 cursor-pointer"
            >
              {" "}
              Digital Artwork Purchase & IP License Agreement
            </span></span></div>
          </div>
        </div>
        <div className="buyNowBox">
          {(wallAddress && wallAddress !== "undefined") ? <><button className="btn btn-secondary text-white py-3 w-100" >Resell</button></> : <button className="btn btn-danger text-white py-3 w-100" onClick={() => navigate("/metamask-sign")} >Connect Metamask</button>}
        </div>

      </Modal>
      <Row>
        <Col lg={12} className="mb-4">
          <div className="d-flex w-100 align-items-center justify-content-between flex-wrap">
            <h1 className="mb-0"><i onClick={menuopen} className="fa-light fa-bars-sort"></i>View Artworks</h1>
          </div>
        </Col>
        <Col lg={12} className="mb-4">
          <div className="ownednftBox">
            <Row>
              <Col className="text-end mx-auto" lg={5}>
                <div className='nftviewBoxNew'>
                  <img src={(user?._id && user?._id === item?.owner_id?._id && item?.saleType === "bid" && item?.ownership_status !== "Completed") ? item?.nft_id?.image_id?.image?.link : item?.nft_id?.image_id?.image?.water_mark_image_link ? item?.nft_id?.image_id?.image?.water_mark_image_link : item?.nft_id?.image_id?.image?.link} className='blurimg' alt="" />
                  <div className="ownednftImgBox cursor-pointer  " onClick={() => viewnftBtn(item)}>
                    <img
                      src={(user?._id && user?._id === item?.owner_id?._id && item?.saleType === "bid" && item?.ownership_status !== "Completed") ? item?.nft_id?.image_id?.image?.link : item?.nft_id?.image_id?.image?.water_mark_image_link ? item?.nft_id?.image_id?.image?.water_mark_image_link : item?.nft_id?.image_id?.image?.link}
                      className="img-fluid"
                      alt=""
                    />
                    <button className=" ownedNewBtn viewBtn "><i class="fa-solid fa-eye"></i> {item?.view_count}</button>

                    <button className=" ownedNewBtn ">{item?.sellType === "fixed" && item?.sale_status !== "sold" ? "On Sale" : (item?.sellType === "auction" && item?.sale_status !== "expired") ? "On Sale" : "Off Sale"}</button>
                  </div>

                </div>
                {Object.keys(artWorkForm || {}).length > 0 &&
                <div className="text-center">
                  <button className="btn btn-primary mx-auto mt-3" onClick={ViewNFT}>Certificate of Authenticity</button>

                  <Modal
                    className="AuthenticityBoxModel uploadimg selectArt text-center"
                    show={showNFT}
                    centered
                    animation={false}
                  >


                    <ViewSaleNFT dialogOpan={ViewNFT} isPhysicalArt={isChecked} sellItem={sellItem} nftId={sellItem?.nft_id?._id} nft={sellItem} showNFT={showNFT} printerName={sellItem?.owner_id?.name + " " + sellItem?.owner_id?.lastname} nftName={sellItem?.nft_id?.name} />
                  </Modal>

                </div>
}
                {((nftPage) || (!nftPage && ownership === "Completed")) &&
                  <ul className="additionalfileOwnednft justify-content-end gap-2 mt-4">

                    <li className="w-100 justify-content-center mb-1">
                      <div className="d-flex align-items-center justify-content-center gap-3">
                        <h4>Download File</h4> <h5><i className="fa-sharp fa-solid fa-circle-check"></i> Available</h5> <button onClick={downloadImage}><i class="fa-light fa-download"></i></button></div> </li>

                  </ul>
                }

              </Col>
              <Col lg={7}>
                <div className="d-flex align-items-center gap-3 tagname">
                  {item?.nft_id?.category_id?.name && <p>#{item?.nft_id?.category_id?.name}</p>}
                  {item?.nft_id?.subcategory?.name && <p>#{item?.nft_id?.subcategory?.name}</p>}
                </div>
                <h2 className="mb-0">{item?.nft_id?.name}</h2>
                <div className="d-flex align-items-center gap-3 tagname mb-3">
                  <p>{item?.nft_id?.collection_id?.name}</p>
                </div>
                <div className="d-flex align-items-center gap-3">
                  <button class="likeBtnNew"><i class="fa-solid fa-heart"></i> {item?.like_count}</button>
                  {ownednft &&
                    <>
                      {resaleActive === true ?
                        (
                          <div className=''>
                            <FormGroup className="form-group mb-0">
                              <Label>Price</Label>
                              <div className="position-relative bidBoxInner resaleboxn  mb-2">
                                <Input type="text" name="price" className="ps-5" />
                                <img src="../../../../images/svg/polygonIcon.svg" width={30} className="position-absolute top-0 bottom-0 start-0 ms-2 my-auto" alt="sth" />
                                <button className="">Submit</button>
                              </div>
                              {/* <p className="mb-0">$12</p> */}
                            </FormGroup>
                          </div>
                        ) : (
                          <button onClick={buynowBtn} className=" btn btn-secondary text-white fw-semibold px-4">Resell</button>
                        )
                      }
                    </>

                  }
                </div>
                <div className="nftviewDatails">
                  <table >
                    <tr>
                      <td>Creator Royalty</td>
                      <td>{item?.loaylty}%</td>
                    </tr>
                    <tr>
                      <td>Collection</td>
                      <td>{item?.nft_id?.collection_id?.name}</td>
                    </tr>
                    <tr>
                      <td>Edition Size </td>
                      <td>{item?.no_of_copies}</td>
                    </tr>
                    {item?.sellType !== "auction" &&
                      <tr>
                        <td>Available Artworks</td>
                        <td>{item?.available_copies}</td>
                      </tr>}
                    {(item?.sellType === "auction" && nftPage === true) && <tr>
                      <td>Total Bids</td>
                      {/* months, days, hours, minutes, seconds  */}
                      <td>{item?.no_of_bids}</td>
                    </tr>
                    }
                    {nftPage === true &&
                      <>   {item.sellType === "auction" && <tr>
                        <td>Current Bid Price</td>
                        <td>{item?.current_price} POL</td>
                      </tr>
                      }
                        {item.sellType === "auction" && <tr>
                          <td>Auction Length</td>
                          <td>{item?.auction_days} {item?.auction_days > 1 ? "Days" : "Day"}</td>

                        </tr>
                        }
                        {item.sellType === "auction" && time && <tr>
                          <td>Auction End Date</td>
                          <td>{daysLeft} {daysLeft > 1 ? "Days" : "Day"} <Timer date={time} /></td>
                        </tr>
                        }

                      </>}
                    <tr>
                      <td>Type</td>
                      <td>{item?.sellType}</td>
                    </tr>

                    {nftPage === true && <tr>
                      <td>Opening Amount</td>
                      <td>{item?.price} POL</td>
                    </tr>
                    }
                  </table>
                </div>

              </Col>

            </Row>
          </div>
        </Col>
        {item?.nft_id?.relatedImages?.link && (
          <Col className="mb-4" lg={12}>

            <div className="bidBox bidBoxNew discriptionBox">
              <>
                <h2 className="d-block w-100">Additional Files </h2>
                <p className="scrollheight">{item?.nft_id?.supportDocDescription}</p>
                <div className="fileBox">
                  <div className="filename">
                    <a href={item?.nft_id?.relatedImages?.link} rel="noreferrer" target="_blank"> {item?.nft_id?.relatedImages?.link?.slice(item?.nft_id?.relatedImages?.link.lastIndexOf(".")).toLowerCase() === ".pdf" ? <i class="fa-regular fa-file-pdf"></i> : item?.nft_id?.relatedImages?.link.slice(item?.nft_id?.relatedImages?.link.lastIndexOf(".")).toLowerCase() === ".png" || ".jpg" || ".jpeg" ? <i class="fa-regular fa-image"></i> : item?.nft_id?.relatedImages?.link.slice(item?.nft_id?.relatedImages?.link.lastIndexOf(".")).toLowerCase() === (".mp4") ? <i class="fa-regular fa-video"></i> : <i class="fa-regular fa-headphones"></i>} View file</a>
                  </div>
                </div>
              </>
            </div>

          </Col>
        )}
        <Col className="mb-4" lg={12}>

          <div className="bidBox bidBoxNew discriptionBox h-100" id="bidBox">
            <h2>Description</h2>
            <p className="scrollheight" >
              {item?.nft_id?.description}
            </p>
            {/* {item?.nft_id?.relatedImages?.link && (<>
              <h2>Additional Files</h2>
              <p>{item?.nft_id?.supportDocDescription}</p>
              <div className="fileBox">
                <div className="filename">
                  <a href={item?.nft_id?.relatedImages?.link} rel="noreferrer" target="_blank"> {item?.nft_id?.relatedImages?.link?.slice(item?.nft_id?.relatedImages?.link.lastIndexOf(".")).toLowerCase() === ".pdf" ? <i class="fa-regular fa-file-pdf"></i> : item?.nft_id?.relatedImages?.link.slice(item?.nft_id?.relatedImages?.link.lastIndexOf(".")).toLowerCase() === ".png" || ".jpg" || ".jpeg" ? <i class="fa-regular fa-image"></i> : item?.nft_id?.relatedImages?.link.slice(item?.nft_id?.relatedImages?.link.lastIndexOf(".")).toLowerCase() === (".mp4") ? <i class="fa-regular fa-video"></i> : <i class="fa-regular fa-headphones"></i>} View file</a>
                
                </div>

              </div>
            </>)} */}


          </div>
        </Col>
      </Row>
    </>
  );
}
const convertUtcToLocal = (utcTimestamp, timezoneOffset) => {
  const utcMoment = moment1.unix(utcTimestamp);
  const localMoment = utcMoment.utcOffset(timezoneOffset);
  return localMoment;
}